export enum ProposalStatus {
	Pending = 1,
	Negotiation,
	Declined,
	Approved,
	Cancelled
}
